import { createContext, useContext, useRef, MutableRefObject } from "react"
import {
  useNavigate,
  NavigateFunction,
  NavigateOptions,
  To,
} from "react-router-dom"
import { appendJamParams } from "./jamDev"

const StableNavigateContext =
  createContext<MutableRefObject<NavigateFunction> | null>(null)

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
const StableNavigateContextProvider = ({ children }) => {
  const navigate = useNavigate()
  const navigateRef = useRef(navigate)

  return (
    <StableNavigateContext.Provider value={navigateRef}>
      {children}
    </StableNavigateContext.Provider>
  )
}

// Why are we doing this? Read this thread - https://github.com/remix-run/react-router/issues/7634
const useStableNavigate = (): NavigateFunction => {
  const navigateRef = useContext(StableNavigateContext)
  if (!navigateRef || navigateRef.current === null) {
    throw new Error("StableNavigate context is not initialized")
  }

  // Wrap the navigate function to automatically persist jam- query params
  const originalNavigate = navigateRef.current

  function jamAwareNavigate(delta: number): void
  function jamAwareNavigate(to: To, options?: NavigateOptions): void
  function jamAwareNavigate(
    toOrDelta: To | number,
    options?: NavigateOptions,
  ): void {
    if (typeof toOrDelta === "number") {
      originalNavigate(toOrDelta)
      return
    }

    const newTo =
      typeof toOrDelta === "string" || typeof toOrDelta === "object"
        ? appendJamParams(toOrDelta, window.location.search)
        : toOrDelta

    originalNavigate(newTo, options)
  }

  return jamAwareNavigate
}

export {
  StableNavigateContext,
  StableNavigateContextProvider,
  useStableNavigate,
}
